import { ACHIEVEMENTS, levelForXp, xpForLevel } from '@kokun/shared';
import { api } from '../../app/api';
import { ui } from '../../app/game-store';
import { button, h, modal, toast } from '../dom';

/** Perfil: nivel, estadísticas, logros, historial y vinculación de cuenta / privacidad. */
export async function openAccount(onLogout: () => void) {
  const p = ui.get().profile!;
  const lvl = levelForXp(p.player.xp);
  const cur = xpForLevel(lvl);
  const next = xpForLevel(lvl + 1);
  const history = await api.history().catch(() => []);
  const user = h('input', { placeholder: 'usuario', autocomplete: 'username', maxLength: 24 }) as HTMLInputElement;
  const pass = h('input', { placeholder: 'contraseña (mín. 8)', type: 'password', autocomplete: 'new-password', maxLength: 128 }) as HTMLInputElement;

  modal(
    `${p.player.name} #${p.player.tag}`,
    [
      h('div', { class: 'xpbar' }, h('b', null, `Nivel ${lvl}`), h('div', { class: 'bar' }, h('i', { style: { width: `${((p.player.xp - cur) / (next - cur)) * 100}%` } })), h('span', { class: 'small' }, `${p.player.xp - cur} / ${next - cur} XP`)),
      h(
        'div',
        { class: 'stats-grid' },
        ...[
          ['🎮', 'Partidas', p.stats.matchesPlayed],
          ['💡', 'Misiones', p.stats.missionsCompleted],
          ['🔋', 'Células', p.stats.cellsDelivered],
          ['🤡', 'Bromas', p.stats.pranksLanded],
          ['🎯', 'Recibidas', p.stats.timesPranked],
          ['🪙', 'Monedas', p.stats.coinsCollected],
        ].map(([i, l, v]) => h('div', { class: 'stat' }, h('span', { class: 'big' }, `${i} ${v}`), h('span', { class: 'small' }, String(l)))),
      ),
      h('h3', null, 'Logros'),
      h('div', { class: 'achievements' }, ...ACHIEVEMENTS.map((a) => h('div', { class: `ach${p.achievements.includes(a.id) ? ' on' : ''}`, title: a.description }, `${a.icon} ${a.name}`))),
      h('h3', null, 'Últimas partidas'),
      history.length
        ? h('ul', { class: 'history' }, ...history.slice(0, 6).map((m) => h('li', null, `${m.success ? '✅' : '❌'} ${new Date(m.playedAt).toLocaleString()} · ${m.score} pts · +${m.xp} XP · ${m.players} jugadores`)))
        : h('p', { class: 'muted' }, 'Todavía no has jugado ninguna partida.'),
      h('h3', null, 'Cuenta'),
      p.player.hasAccount
        ? h('p', null, `Cuenta vinculada como `, h('b', null, p.player.username ?? ''), '. Puedes entrar desde cualquier dispositivo.')
        : h(
            'div',
            null,
            h('p', { class: 'muted small' }, 'Eres invitado: tu progreso vive en este navegador. Crea usuario y contraseña para conservarlo en otros dispositivos.'),
            h('div', { class: 'row' }, user, pass),
            button(
              'Vincular cuenta',
              async () => {
                try {
                  const r = await api.register(user.value, pass.value);
                  ui.set({ profile: r.profile });
                  toast('¡Cuenta vinculada!', 'success');
                } catch (e) {
                  toast((e as Error).message, 'error');
                }
              },
              'btn primary small',
            ),
          ),
      h(
        'div',
        { class: 'row' },
        button('Cerrar sesión', async () => {
          await api.logout();
          onLogout();
        }, 'btn ghost small'),
        button(
          'Borrar mi cuenta y datos',
          () =>
            void modal('¿Borrar todo?', 'Se eliminarán tu personaje, tu cara, tus estadísticas y tu historial. No se puede deshacer.', [
              { label: 'Cancelar', cls: 'btn ghost', run: () => undefined },
              {
                label: 'Borrar definitivamente',
                cls: 'btn danger',
                run: async () => {
                  await api.deleteAccount();
                  api.token = null;
                  toast('Cuenta eliminada.', 'success');
                  onLogout();
                },
              },
            ]),
          'btn danger small',
        ),
      ),
    ],
    [{ label: 'Cerrar', cls: 'btn primary', run: () => undefined }],
    { wide: true },
  );
}
